var ProductPage = {};

ProductPage.product = {};

ProductPage.init = function () {
  var pageEl = $('[data-product-id]');
  if (!pageEl.length) {
    return;
  }
  ProductPage.initGallery();
  ProductPage.product._id = pageEl.attr("data-product-id");
  ProductPage.product.versions = [];
  $('#add-to-cart').click(ProductPage.addToCartClick);

  $('.notifyMe_open').click(function () {
    ProductNotifyModal.open(ProductPage.product);
  });

  ProductPage.product.isOneVesion = pageEl.attr('data-product-versions-qty') === "1";

  if (ProductPage.product.isOneVesion) {
    ProductPage.product.versions.push(pageEl.attr("data-product-version"));
  }
  // ProductPage.chooseSizeSelect = $('#chooseSize')
  //   .select2()
  //   .on('select2:select', function (e) {
  //     if (e.params.data) {
  //       ProductPage.versionChanged(e.params.data.id);
  //     }
  //   });
  ProductPage.initSizeSelectButtons();

  $('#zapytaj-o-produkt-form').submit(ProductPage.sendEnquiry);

  //$('.engrave_modal_open').click(ProductPage.openEngraveModal);


  if (pageEl.attr("data-is-fav") === 'true') {
    $('.fav').hide();
    $('.unfav').show();
  }

  pageEl.find('.fav').on("click", function (evt) {
    Fav.favProduct(ProductPage.product._id, function () {
      Fav.loadFavs();
      $('.fav').hide();
      $('.unfav').show();
    });
  });

  pageEl.find('.unfav').on("click", function (evt) {
    evt.preventDefault();
    Fav.unFavProduct(ProductPage.product._id, function () {
      Fav.loadFavs();
      $('.fav').show();
      $('.unfav').hide();
    });
  });


  var $productTabs = $('.product__overview');

  if ($productTabs.length) {
    $productTabs.find(".tabs-nav a").click(function (event) {
      event.preventDefault();
      $(this).parent().addClass("active");
      $(this).parent().siblings().removeClass("active");
      var tab = $(this).attr("href");
      $productTabs.find(".tab").not(tab).css("display", "none");
      $(tab).fadeIn();
    });
  }

};

// ProductPage.openEngraveModal = function () {
//   EngraveModal.loadModal(ProductPage.product, {
//     onAddToCart: function (engraveItem) {
//       Cart.addItems([ProductPage.getChosenItems(), engraveItem])
//     }
//   })
// };

ProductPage.sendEnquiry = function (evt) {
  evt.preventDefault();
  var form = document.forms.zapytajOProdukt;
  Forms.clearFormErrors(form);
  var errors = Forms.validateFields(form, ProductPage.enquiryFields);
  if (errors.length > 0) {
    return;
  }
  var formData = {
    name: form.username.value,
    email: form.email.value,
    message: form.message.value,
    subject: form.subject.value
  };
  jQuery.ajax({
    url: "/product/ask",
    method: "post",
    data: JSON.stringify(formData),
    contentType: 'application/json; charset=utf-8',
    success: function (resp) {
      if (resp.success) {
        $('.form').hide();
        $('#success-message').removeClass('hidden');
      }
    }
  });
};

ProductPage.enquiryFields = [
  {name: "formName", required: true},
  {name: "formEmail", required: true},
  {name: "formMessage", required: true}
];

/**
 * Returns an array of items as below that can be added to the Cart
 * @returns {{type: string, product: *, version: T, qty: number}[]}
 */
ProductPage.getChosenItems = function () {
  if (ProductPage.product.versions.length === 0) {
    return [];
  }
  return ProductPage.product.versions.map(function (versionId) {
    return {
      type: "product",
      product: ProductPage.product._id,
      version: versionId,
      qty: 1
    }
  });
};

ProductPage.versionChanged = function (versionId) {
  var pos = ProductPage.product.versions.indexOf(versionId);
  if (pos >= 0) {
    ProductPage.product.versions.splice(pos, 1);
  } else {
    ProductPage.product.versions.push(versionId);
  }
};

ProductPage.initGallery = function () {
  // Single product slider
  var single_product_slider = new Swiper('.single_product_slider', {
    spaceBetween: 10,
    autoHeight: true,
    navigation: {
      nextEl: '.single_product_slider .swiper-button-next',
      prevEl: '.single_product_slider .swiper-button-prev',
    },
    preloadImages: false,
    lazy: {
      loadPrevNext: true
    },
    loadPrevNext: true,
    pagination: {
      el: '.single_product_slider .swiper-pagination',
      clickable: true,
      type: 'bullets'
    },
    breakpoints: {
      992: {
        autoHeight: false
      }
    }
  });

  $(window).resize(function () {
    single_product_slider.update();
    // single_product_slider_nav.update();
  });
};

ProductPage.loadViewedProducts = function () {
  //todo:
};

ProductPage.loadSimilarProducts = function () {
  //todo:
};

ProductPage.addToCartClick = function () {
  var selected = ProductPage.getChosenItems();
  if (selected.length === 0) {
    VersionModal.loadModal(ProductPage.product._id, {
      onAddToCart: function (items) {
        Cart.addItems(items.map(function (item) {
          return {
            type: item.type,
            product: ProductPage.product._id,
            version: item.version,
            qty: 1
          }
        }));
      }
    });
  } else {
    Cart.addItems(selected);
  }
};

// ProductPage.addToCartFromEngraverClick = function () {
//   Cart.addItems({
//     type: "product",
//     product: ProductPage.product._id,
//     version: ProductPage.product.version,
//     qty: 1
//   }, {
//     type: "engrave",
//     product: ProductPage.product._id,
//     qty: 1,
//     font: "",
//     text: ""
//   });
// };

ProductPage.showGalleryZoomModal = function () {

};

ProductPage.initSizeSelectButtons = function () {
  var buttons = $('.list button');
  buttons.each(function () {
    var $btn = $(this);
    $btn.click(function () {
      if ($btn.hasClass("disabled")) {
        return Cart.showOutOfStockModel($btn.text(), $btn.attr('data-value'));
      }
      if ($btn.hasClass("inactive")) {
        $btn.addClass("active").removeClass("inactive");
      } else if ($btn.hasClass("active")) {
        $btn.addClass("inactive").removeClass("active");
      } else {
        $btn.addClass("active").removeClass("inactive");
      }
      //$(this).toggleClass('active');
      ProductPage.versionChanged(this.dataset.value);
    });
  });
};

$(ProductPage.init);


